import { defineMessages } from 'react-intl';

export default defineMessages({
    searchContactTitle: {
        id: 'gateway.views.farm.additional-contacts.Search Address Book',
        defaultMessage: 'Search Address Book',
    },
    additionalContactType: {
        id: 'gateway.views.farm.additional-contacts.ContactType',
        defaultMessage: 'Type',
    },
    additionalPerson: {
        id: 'gateway.views.farm.additional-contacts.Person',
        defaultMessage: 'Person',
    },
    additionalCompany: {
        id: 'gateway.views.farm.additional-contacts.Company',
        defaultMessage: 'Company',
    },
    addNew: {
        id: 'gateway.views.farm.additional-contacts.Add New',
        defaultMessage: 'Add New',
    },
    cancelSearch: {
        id: 'gateway.views.farm.additional-contacts.Cancel',
        defaultMessage: 'Cancel',
    },
    searchAdditionalContact: {
        id: 'gateway.views.farm.additional-contacts.Search',
        defaultMessage: 'Search',
    },
    additionalContactFirstName: {
        id: 'gateway.views.farm.additional-contacts.FirstName',
        defaultMessage: 'First Name',
    },
    additionalContactLastName: {
        id: 'gateway.views.farm.additional-contacts.LastName',
        defaultMessage: 'Last Name',
    },    
    contactHeaderName: {
        id: 'gateway.views.farm.additional-contacts.Name',
        defaultMessage: 'Name'
    },
    contactHeaderAddress: {
        id: 'gateway.views.farm.additional-contacts.Address',
        defaultMessage: 'Address'
    },
    noContacts: {
        id: 'gateway.views.farm.additional-contacts.No results found!',
        defaultMessage: 'No Contacts'
    }
});
